import React from 'react';
import { Col, Row } from 'reactstrap';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { Breadcrumbs } from './types';
import { SMLBreadcrumb } from './SMLBreadcrumb';
import styles from './SMLBreadcrumbs.module.scss';

interface SMLBreadcrumbsProps {
  breadcrumbs: Breadcrumbs;
  suffix?: React.ReactNode;
  /** `eyebrow`: the small mono crumbs of navigation v2 (design e 5c). Default: a heading. */
  variant?: 'heading' | 'eyebrow';
  /** Hide the crumbs below 769 px, where the mobile top bar shows back + the title (design 7f). */
  hideCrumbsOnPhone?: boolean;
}

const SMLBreadcrumbsComponent: React.FC<React.PropsWithChildren<SMLBreadcrumbsProps>> = ({
  breadcrumbs,
  suffix,
  variant = 'heading',
  hideCrumbsOnPhone = false,
  children,
}) => {
  const crumbs = breadcrumbs.map((breadcrumb, index) => (
    <SMLBreadcrumb key={breadcrumb.name} breadcrumb={breadcrumb} isLast={index === breadcrumbs.length - 1} />
  ));

  return (
    <Row className="align-items-center">
      <Col className={clsx('d-flex align-items-center', hideCrumbsOnPhone && styles.hideOnPhone)}>
        {variant === 'eyebrow' ? (
          <nav className={clsx('me-2', styles.eyebrow)}>{crumbs}</nav>
        ) : (
          <h3 className="mb-0 me-2">{crumbs}</h3>
        )}
        {suffix}
      </Col>
      {children !== undefined ? <Col className="d-flex justify-content-sm-end col-auto">{children}</Col> : null}
    </Row>
  );
};

export const SMLBreadcrumbs = TypedMemo(SMLBreadcrumbsComponent);
